import { ISchemaFields, ISchemaForm, IUiFields } from '../../../../common/SchemaForm/utils';

export const fieldSchema: ISchemaFields = ({ formProps }) => {
  const { intl } = formProps || {};
  return {
    name: {
      type: 'text-field',
      label: intl.formatMessage({ id: 'exam.packageName' }),
      placeholder: intl.formatMessage({ id: 'exam.packageNameEnter' }),
      autoFocus: true,
      register: {
        required: true,
      },
    },
  };
};

const ui: IUiFields = () => {
  return [
    {
      id: 'info',
      fields: ['name'],
    },
  ];
};

export const groupExamPriceFormSchema: ISchemaForm = {
  fields: fieldSchema,
  ui: ui,
};
